import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { MobileStepper } from '@mui/material';


const StepperBiodiversidadComponent = ({position, setPosition}) => {

    const steps = [
        'General',
        'Objeto de análisis',
        'Protocolo de muestreo',
        'Datos'
    ];

    return(
        <Box sx={{ width: '100%', marginTop: '40px' }}>
            <Stepper className={steps.length > 2 ? "stepper-dsk" : ""} activeStep={position} alternativeLabel>
                {steps.map((label, i) => (
                <Step key={label} onClick={() => setPosition(i)} sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                      color: '#80C606',
                    },
                    '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                      {
                        color: 'grey.500',
                      },
                    '& .MuiStepLabel-root .Mui-active': {
                      color: '#80C606',
                    },
                    '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                      {
                        color: 'rgba(0, 0, 0, 0.87)',
                      },
                    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                      fill: 'white',
                    },
                  }}>
                    <StepLabel>{label}</StepLabel>
                </Step>
                ))}
            </Stepper>
            <MobileStepper className={steps.length <= 2 ? "hide" : "stepper-mv"}
            variant="dots"
            steps={steps.length}
            activeStep={position}
            position='static'
            sx={{
              '&.MuiMobileStepper-root .MuiMobileStepper-dots': {
                width: '100%',
                justifyContent: 'space-between',
              },
              '&.MuiMobileStepper-root':
                {
                  padding: '0',
                  margin: '20px 0 40px 0',
                },
              '&.MuiMobileStepper-root .MuiMobileStepper-dot.MuiMobileStepper-dotActive': {
                backgroundColor: '#80C606',
              },
              '&.MuiMobileStepper-root .MuiMobileStepper-dot':{
                width: '15px',
                height: '15px',
              },
            }}
            >

            </MobileStepper>
          </Box>
    );
}
export default StepperBiodiversidadComponent;